export default __webpack_public_path__ + "static/media/review4.480180d1.jpg";